import { useEffect, useState } from "react";
import { useLang } from "../context/LangContext";
import { api } from "../lib/api";
import { Seo } from "../components/Seo";
import BrandGrid from "../components/BrandGrid";
import NeuralBackground from "../components/NeuralBackground";

export default function Ecosistema() {
  const { t } = useLang();
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/public/brands").then((r) => setBrands(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="ecosystem-page">
      <Seo page="ecosistema" />
      <section className="relative border-b border-slate-200 overflow-hidden">
        <NeuralBackground />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-24">
          <span className="font-mono-tech text-xs tracking-[0.3em] text-[#5698C7]">ECOSISTEMA</span>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4" data-testid="ecosystem-title">{t("eco_title")}</h1>
          <p className="text-slate-600 max-w-2xl mt-6">{t("eco_sub")}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <BrandGrid brands={brands} />
      </section>
    </div>
  );
}
